import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NewLicenseServerInterface } from '../models/licenseServer';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class LicenseServerService {

  constructor(private http: HttpClient, private env: EnvironmentService) { }

  getAllLicenseServer(){
    let baseUrl =  this.env.envVariables.httpProtocol +  this.env.envVariables.webHost + 'SyncVDI/LicenseServer/GetAll';
    return this.http.get(baseUrl);
  }

  addLicenseServer(licenseObj: NewLicenseServerInterface){
    let baseUrl =  this.env.envVariables.httpProtocol +  this.env.envVariables.webHost + 'SyncVDI/LicenseServer/Add';
    return this.http.post(baseUrl, licenseObj);
  }

  updateLicenseServer(oldLicenseName: string, newLicenseObj: NewLicenseServerInterface){
    let baseUrl =  this.env.envVariables.httpProtocol +  this.env.envVariables.webHost + 'SyncVDI/LicenseServer/Update/' + oldLicenseName;
    return this.http.put(baseUrl, newLicenseObj);
  }

  deleteLicenseServer(licenseName: string){
    let baseUrl =  this.env.envVariables.httpProtocol +  this.env.envVariables.webHost + 'SyncVDI/LicenseServer/Delete/' + licenseName;
    return this.http.delete(baseUrl);
  }

  getLicenseInfoForServer(serverName: string){
    let baseUrl =  this.env.envVariables.httpProtocol +  this.env.envVariables.webHost + 'SyncVDI/LicenseServer/licenseInfo/' + serverName;
    return this.http.get(baseUrl);
  }
  getLisenceSummary() {
    let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + 'SyncVDI/LicenseServer/LicenseSummary';
    return this.http.get(baseUrl);
  }
}
